import axios from 'axios';

const api = axios.create({
    //baseURL: 'https://api.vitaminfun.net/api',
    baseURL: 'https://apiweb.tantriedu.vn/api',
    //baseURL: 'http://localhost:5005/api',
});
/*
api.interceptors.request.use(
    (config) => {
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        if (auth && auth.token) {
            config.headers['Authorization'] = `Bearer ${auth.token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
*/

// Thêm interceptor để tự động gắn token vào header
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
export default api;